class Countdown extends HTMLElement {
  constructor() {
    super();

    this.countdownDate = this.getAttribute("data-countdown")
      ? new Date(this.getAttribute("data-countdown")).getTime()
      : null;
    this.days = this.querySelector(".days");
    this.hours = this.querySelector(".hours");
    this.mins = this.querySelector(".minutes");
    this.secs = this.querySelector(".seconds");
    this.element = this.getAttribute("data-element-to-hide");
    this.hideZero = this.getAttribute("data-hide-zero") === "true";
    this.hideZeroDays = this.getAttribute("data-hide-zero-days") === "true";

    if (
      this.countdownDate &&
      this.days &&
      this.hours &&
      this.mins &&
      this.secs
    ) {
      // Update the count down every 1 second
      const timer = setInterval(() => {
        // Get today's date and time
        const now = new Date().getTime();

        // Find the difference between now and the count down date
        const difference = this.countdownDate - now;

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const mins = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((difference % (1000 * 60)) / 1000);

        // Time calculations for days, hours, minutes and seconds
        this.days.innerHTML = `${days > 0 ? days : 0} <span class="suffix">${
          days == 1 ? window.countdownStrings.day : window.countdownStrings.days
        }</span>`;

        if (days < 1 && this.hideZeroDays) {
          this.days.classList.add("hidden");
        } else {
          this.days.classList.remove("hidden");
        }

        this.hours.innerHTML = `${hours > 0 ? hours : 0} <span class="suffix">${
          hours == 1
            ? window.countdownStrings.hour
            : window.countdownStrings.hours
        }</span>`;

        if (hours < 1 && this.hideZero) {
          this.hours.classList.add("hidden");
        } else {
          this.hours.classList.remove("hidden");
        }

        this.mins.innerHTML = `${mins > 0 ? mins : 0} <span class="suffix">${
          mins == 1 ? window.countdownStrings.min : window.countdownStrings.mins
        }</span>`;

        if (mins < 1 && this.hideZero) {
          this.mins.classList.add("hidden");
        } else {
          this.mins.classList.remove("hidden");
        }

        this.secs.innerHTML = `${secs > 0 ? secs : 0} <span class="suffix">${
          window.countdownStrings.secs
        }</span>`;

        // If the count down is finished, stop
        if (difference <= 0) {
          clearInterval(timer);
          if (this.element) {
            if (Shopify.designMode) {
              document.getElementById(this.element).innerHTML = "Countdown hidden as date has already passed"
            } else {
              this.hideElement();
            }
          }
        }
      }, 1000);
    }
  }

  hideElement() {
    const elementById = document.getElementById(this.element);
    if (elementById) {
      elementById.classList.add("hidden");
    }
  }
}

customElements.define("countdown-timer", Countdown);
